import React, { useState } from 'react';
import chevron_icon from 'assets/chevron-down.svg';
import { ChatFAQ } from 'services/api/chatsApi';
import styled from 'styled-components';

interface FAQSectionProps {
  faq: ChatFAQ[];
}

const FAQSection: React.FC<FAQSectionProps> = ({ faq }) => {
  const [opened, setOpened] = useState<number[]>([]);

  if (!faq || faq.length === 0) return null;

  return (
    <Wrapper>
      <Header>
        Frequently Asked <span style={{ color: 'rgb(255,126,85)' }}>Questions</span>
      </Header>
      <FaqPlaceholder>
        {faq.map((item, index) => {
          const isOpened = opened.includes(index);
          return (
            <QuestionPlaceholder
              key={index}
              onClick={() => setOpened(isOpened ? opened.filter(x => x !== index) : [...opened, index])}
            >
              <div className="flex items-center justify-between space-x-4">
                <Question>{item.question}</Question>
                <img
                  src={chevron_icon}
                  alt="chevron"
                  className={`transform transition-transform duration-300 ${isOpened ? 'rotate-180' : ''}`}
                />
              </div>
              <Answer isOpened={isOpened}>{item.answer}</Answer>
            </QuestionPlaceholder>
          );
        })}
      </FaqPlaceholder>
    </Wrapper>
  );
};

export default FAQSection;

const Wrapper = styled.div`
  width: 100%;
  color: white;
  margin-bottom: 48px;
  
  @media (max-width: 968px) {
    margin-left: 16px;
    margin-right: 16px;
  }
`;

const Header = styled.h2`
  font-family: Raleway;
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
  margin-bottom: 32px;
  
  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 36px;
  }
`;

const FaqPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const QuestionPlaceholder = styled.div`
  background-color: rgba(29, 29, 29, 1);
  padding: 24px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
`;

const Question = styled.h3`
  font-family: Nunito Sans;
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
`;

const Answer = styled.div<{ isOpened: boolean }>`
  font-family: Nunito Sans;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(169, 169, 169, 1);
  white-space: pre-line;
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  margin-top: 0;

  ${props => props.isOpened && `
    height: auto;
    opacity: 1;
    margin-top: 16px;
  `}
`; 